import React, { useEffect, useState, useRef, Fragment } from 'react';
import './index.scss'
import history from '../../History'
import Dialog from '../../Components/Dialog'
import {getAllUrlParams, json2keyval, getQueryString} from '../../Utils/Utils'
import LightMobileCall from '@kugou/light-mobilecall';
import mobileLog from '../../Utils/Utils/mobileLog';

export default function RemixBackend() {
  //提示弹窗
  const [showTipsDialog, setShowTipsDialog] = useState(false)
  const [tipsContent, setTipsContent] = useState('')

  //提示弹窗
  function showTips(word) {
    setTipsContent(word)
    setShowTipsDialog(true)
  }

  const configOriginal = [{
    //icon: 'https://webimg.kgimg.com/166af12ed6301cced890dac8c51b7966.png',
    title: 'Remix音乐人',
    to: '/backend',
    alt: 'Remix音乐人'
  }]

  const configRe = [{
    icon: 'https://webimg.kgimg.com/3cf2f9dbf7b9adfc6f255647a90edc00.png',
    title: '原创',
    to: '/enter',
    alt: '原创'
  },
  {
    icon: 'https://webimg.kgimg.com/78e42166d33c17734bf06f5f4996a0fe.png',
    title: '翻唱',
    to: '/re-create',
    alt: '翻唱'
  }]

  //进入后台
  function goBackEnd(){
    //透传所有url参数
    let params = getAllUrlParams();
    window.location.replace('https://h5.kugou.com/musicianService/v-6d9959c0/index.html?isHideTitleBar=1&type=1&norule=1'+(Object.keys(params).length?'&'+json2keyval(params):''))
  }

  function goToPage(path) {
    window.$getUserStatus(({ status, users }) => {
      if( path === '/backend' ){
        mobileLog({
          a: 23299,
          b: '点击',
          ft: '差一步进入remix后台页面',
          r: 'Remix音乐人',
          channel: 'H5'
        })
        setTimeout(() => {
          goBackEnd()
        }, 300);
        return;
      }

      if( path === '/re-create' ){//翻唱跳转的也是入驻页面
        mobileLog({
          a: 23300,
          b: '点击',
          ft: '差一步进入remix后台页面',
          r: '原唱翻唱入驻入口',
          svar1: '翻唱'
        })
        path = '/enter'
        localStorage.setItem(`enter-musician-${window.$userInfo.userid}`, '2')
      }else if( path === '/enter'){
        mobileLog({
          a: 23300,
          b: '点击',
          ft: '差一步进入remix后台页面',
          r: '原唱翻唱入驻入口',
          svar1: '原唱'
        })
        localStorage.setItem(`enter-musician-${window.$userInfo.userid}`, '1')
      }
      if ( path === '/enter') {
        // 入驻成功的，直接跳转去数据页
        if (~[1, 3, 4, 21, 31].indexOf(status)) {
          setTimeout(() => {
            goBackEnd()
          }, 300);
          return;
        }
        path = path + '/' + window.encodeURIComponent(JSON.stringify({ status }))
      }

      history.go(path)
      return;
    })
  }

  useEffect(() => {
    //左上角点击退出
    window.LC.mobileCall(710, { type: 0 })
    if ( window.LC.isInClient() ) {
      window.$mustLogin( () => {} )
    }
    /* setTimeout(() => {
      if(window.LC.isIOS){
        window.LC.mobileCall(602, { title: 'Remix后台' });
      }else{
        window.LC.mobileCall(166, { title: 'Remix后台' });
      }
    }, 50) */
    LightMobileCall.mobileCall(1203)
  }, [])

  return (<div className="RemixBackend">

    <div className="container">
      {/* 入驻相关模块 */}
      <div>
        {configOriginal.map((ele, index) => (<section key={index} className="item" onClick={() => goToPage(ele.to)}>
          {ele.icon && <img src={ele.icon} alt={ele.alt} />}
          <p className={"title pl0" + (ele.subTitle ? ' parallel' : '')}>{ele.title}</p>
          {ele.desc && <p className="desc">{ele.desc}</p>}
          {ele.subTitle && <p className="subTitle">{ele.subTitle}</p>}
        </section>))}
      </div>
      <p className="enterTitle">入驻</p>
      <div>
        {configRe.map((ele, index) => (<section key={index} className="item" onClick={() => goToPage(ele.to)}>
          <img src={ele.icon} alt={ele.alt} />
          <p className={"title" + (ele.subTitle ? ' parallel' : '')}>{ele.title}</p>
          {ele.desc && <p className="desc">{ele.desc}</p>}
          {ele.subTitle && <p className="subTitle">{ele.subTitle}</p>}
        </section>))}
      </div>
    </div>
    <Dialog title="提示" visible={showTipsDialog} setVisible={setShowTipsDialog} btns={[{ text: '知道了', fn: () => setShowTipsDialog(false) }]}>
      <div className="dialogText">{tipsContent}</div>
    </Dialog>
  </div>)
} 